import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MoreInfoTooltipComponent } from "app/shared/standalone/components/more-info-tooltip/more-info-tooltip.component";
import { ClickElsewhereDirective } from "app/shared/standalone/directives/click-elsewhere.directive";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-file-input",
  templateUrl: "./file-input.component.html",
  styleUrls: ["./file-input.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, MoreInfoTooltipComponent, ClickElsewhereDirective, TranslateModule]
})
export class FileInputComponent {
  public fileName: string;
  @Input() labelText: string = "COMMON.INPUT_FILE.LABEL";
  @Input() inputText: string = "COMMON.INPUT_FILE.PLACEHOLDER";
  @Input() buttonText: string = "COMMON.INPUT_FILE.BUTTON_TEXT";
  @Output() fileChange = new EventEmitter<File>();

  public handleAddFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const selectedFile = input.files[0];
    this.fileName = selectedFile.name;

    this.fileChange.emit(selectedFile);
  }
}
